const btnManagementService = {
  label: 'filters',
  Typography: 'No results found'
};

export default btnManagementService;
